<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                title="Add Challan Register"
                :showBtn="true"
                @onClickCloseButton="goToList"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 mb-1">
                    <label for="colFormLabel" class="col-form-label">TDS / VDS</label>
                    <div class="challan-inline-spacing">
                        <div @click="onHandleClick('tds')" class="form-check form-check-inline mt-0">
                            <input 
                                v-model="sectionType" 
                                class="form-check-input" 
                                type="radio" name="inlineRadioOptions"
                                id="inlineRadio1"
                                value="tds"
                            />
                            <label class="form-check-label" for="inlineRadio1">TDS</label>
                        </div>

                        <div @click="onHandleClick('vds')" class="form-check form-check-inline mt-0">
                            <input v-model="sectionType" 
                                class="form-check-input"
                                type="radio" name="inlineRadioOptions"
                                id="inlineRadio2"
                                value="vds"
                            />
                            <label class="form-check-label" for="inlineRadio2">VDS</label>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1" v-if="sectionType === 'vds'">
                    <label for="colFormLabel" class="col-form-label">VDS Section Ref</label>
                    <v-select
                        placeholder="Select VDS Section Ref"
                        :options="vdsRateList"
                        :reduce="item => item.id"
                        label="name"
                        v-model="params.vds_rate_id"
                    />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1" v-if="sectionType === 'tds'">
                    <label for="colFormLabel" class="col-form-label">TDS Section Ref</label>
                    <v-select
                        placeholder="Select TDS Section Ref"
                        :options="tdsRateList"
                        :reduce="item => item.id"
                        label="name"
                        v-model="params.tds_rate_id"
                    />
                </div>
                
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                    <label for="colFormLabel" class="col-form-label">Accounting Head</label>
                    <v-select
                        :options="accountHeads"
                        label="name"
                        :reduce="(item) => item.id"
                        placeholder="Select head"
                        v-model="params.account_head_id"
                    />
                </div>
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mb-1">
            <ListTable 
                :tableItems="tableItems"
            />
        </div>

        <div class="px-2">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <div class="row gy-1 p-2">
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Voucher Date</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder="Select Voucher Date"
                    v-model="formData.voucher_date"
                >
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Paid From</label>
                <v-select
                    placeholder="Select Cash & Bank Account"
                    class="w-100"
                    v-model="formData.mop_account_head_id"
                    :options="cashAndBank"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Payment Purpose</label>
                <v-select
                    placeholder="Select payment purpose"
                    class="w-100"
                    v-model="formData.payment_account_head_id"
                    :options="accountHeadList"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Paid Amount</label>
                <input
                    v-model="formData.amount"
                    type="number"
                    class="form-control text-end"
                    placeholder="Amount"
                >
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Challan No.</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="text"
                    placeholder="Enter Challan No."
                    v-model="formData.challan_no"
                >
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Challan Date</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder="Select Challan Date"
                    v-model="formData.challan_date"
                >
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Bank - Branch</label>
                <AsyncSelect
                    placeholder="Select Bank-Branch"
                    v-model="dealer"
                    :api-service="fetchAllDealers"
                    label="name"
                />
            </div>
            <div class="col-12">
                <div class="mb-1">
                    <label class="form-label" for="remarks">Remarks</label>
                    <vField
                        as="textarea"
                        name="remarks"
                        type="number"
                        class="form-control"
                        placeholder="Enter Remarks"
                        v-model="formData.remarks"
                    />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-2">
                    <label for="attachment" class="form-label fw-bold">Attachment</label>
                    <BlobFileViewer :attachments="attachments" />
                    <FileUpload
                        :is-drag-active="true"
                        button-text="Upload Documents"
                        v-model="attachments"
                    >
                    </FileUpload>
                </div>
            </div>

            <div class="col-12 text-center mb-2">
                <hr>
                <SubmitCancelBtn
                    class="text-center"
                    @onSubmit="submit"
                    @onCancel="goToList"
                    :loading="isLoading"
                />
            </div>
        </div>

        <Loader v-if="loading"/>
        
        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            :isFilterable="true"
            :companyRoles="companyRoles"
        />
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/compliance/challan-register/ChallanPostingTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleCompliance from '@/services/modules/compliance/compliance';
import handleReport from "@/services/modules/accountingReport";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import { computed } from 'vue';
import handleTdsVds from '@/services/modules/procurement/tdsVds'
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import FileUpload from "@/components/atom/FileUpload";
import handlePayment from '@/services/modules/payment'
import handleJournal from '@/services/modules/journal'
import handleCrm from '@/services/modules/crm/crm';
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { cloneDeep } from 'lodash';
import useDate from "@/services/utils/day";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfile = ref(null);
const accountHeads = ref([]);
const accountHeadList = ref([]);
const companyRoles = ref([]);
const tableItems = ref([]);
const cashAndBank = ref([]);
const params = ref({
    offset: 10,
    tds_rate_id: null,
    vds_rate_id: null,
    payment_status: null,
    account_head_id: null,
    contact_profile_id: null
});
const tdsRateList = ref([]);
const vdsRateList = ref([]);
const paymentStatuses = ref([]);
const sectionType = ref('tds');
const attachments = ref([]);
const dealer = ref(null);
const isLoading = ref(false);

const formData = ref({
    company_id: route.params.companyId,
    from: null,
    to: null,
    section_ref_id: null,
    section_ref_type: null,
    account_head_id: null,
    dealer_id: null,
    challan_no: null,
    challan_date: null,
    amount: null,

    contact_profile_id: null,
    voucher_date: null,
    payment_account_head_id: null,
    mop_account_head_id: null,
    paid_amount: null,

    generals: [],
})

const { fetchTdsVdsRegister, storeChallanRegister } = handleCompliance();

const {
  firstDateOfMonth,
  lastDateOfMonth
} = useDate()

const { fetchCashAndBank } = handlePayment()
const { fetchAccountHeads } = handleReport();
const { fetchTdsRateList, fetchVdsRateList } = handleTdsVds();
const { fetchAccountHeadsList } = handleJournal();
const { fetchAllDealers } = handleCrm();

const submit = async () => {
    const formattedData = formatFormData();

    isLoading.value = true

    await storeChallanRegister(formattedData).then((res) => {
        isLoading.value = false
        if (!res.status) return showError(res.message);
        showSuccess(res.message);
        goToList();
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        isLoading.value = false
    })
}

const formatFormData = () => {
    const data = cloneDeep(formData.value);
    const copyFormData = new FormData();

    for(const key in data) {
        copyFormData.append(key, (data[key] || ''));
    }
    
    if(dealer.value) copyFormData.append('dealer_id', dealer.value.id);``

    tableItems.value.forEach((item, index) => {
        if(! item.account_head_id) return;

        copyFormData.append(`generals[${index}][account_head_id]`, item.account_head_id);
        copyFormData.append(`generals[${index}][registerable_id]`, item.id);
        copyFormData.append(`generals[${index}][section_ref_id]`, sectionType.value === 'tds' ? item.tds_rate_id : item.vds_rate_id);
        copyFormData.append(`generals[${index}][registerable_type]`, item.register_type);
        copyFormData.append(`generals[${index}][section_ref_type]`, sectionType.value);
        copyFormData.append(`generals[${index}][amount]`, item.bill_amount);
    })

    const previousFileIds = [];

    for(const key in attachments.value){
        if(typeof attachments.value[key] === 'object' && attachments.value[key].hasOwnProperty('id')) {
            previousFileIds.push(attachments.value[key].id);
            continue;
        }
        copyFormData.append('attachments[]', attachments.value[key]);
    }

    copyFormData.append('previous_file_ids', JSON.stringify(previousFileIds))

    return copyFormData;
}

const goToList = () => {
    router.push({
        name: 'challan-register',
        params: route.params,
        query: {start: firstDateOfMonth, end: lastDateOfMonth}
    });
}

const onClickToGo = () => {

    if(! params.value.tds_rate_id && !params.value.vds_rate_id) {
        return showError('Please, select section ref first.');
    }
    
    formData.value.from = route.query.start;
    formData.value.to = route.query.end;
    formData.value.account_head_id = params.value.account_head_id;
    formData.value.section_ref_type = sectionType.value;
    formData.value.section_ref_id = sectionType.value === 'tds' ? params.value.tds_rate_id : params.value.vds_rate_id;

    getTdsVdsList();
}

const onHandleClick = (type) => {
    sectionType.value = type;
    params.value.tds_rate_id = null;
    params.value.vds_rate_id = null;
}

const onSearchContact = (contact) => {
    contactProfile.value = contact
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    getTdsVdsList();
}

const getAccountHeads = async () => {
    let res = await fetchAccountHeads(route.params.companyId);
    if (res.status) {
      accountHeads.value = res.data;
    }
}

const getCashAndBank = async () => {
    let res = await fetchCashAndBank(route.params.companyId);
    if (res.status) {
      cashAndBank.value = res.data;
    }
}

const getAccountHeadList = async () => {
    let accountHeadQuery = `?company_id=${route.params.companyId}&cash_bank_hide=yes&status=active`;
    const res = await fetchAccountHeadsList(accountHeadQuery);
    if (res.status) {
        accountHeadList.value = res.data
    }
}

const getTdsRates = async () => {

    let query =  getQuery();
    query += '&with_code=1';

    await fetchTdsRateList(query).then(res => {
        if(res.status){
            tdsRateList.value = res.data;
        }
    }).catch(err => {
        console.log(err)
    })
}

const getVdsRates = async () => {

    let query =  getQuery();
    query += '&with_code=1';

    await fetchVdsRateList(query).then(res => {
        if(res.status){
            vdsRateList.value = res.data;
        }
    }).catch(err => {
        console.log(err)
    })
}

const getTdsVdsList = async () => {

    const query = getQuery();
    
    loading.value = true

    await fetchTdsVdsRegister(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }

        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (params.value.contact_profile_id) query += '&contact_profile_id=' + params.value.contact_profile_id;
    if (params.value.account_head_id) query += '&account_head_id=' + params.value.account_head_id;
    if (params.value.payment_status) query += '&payment_status=' + params.value.payment_status;
    if (params.value.tds_rate_id) query += '&tds_rate_id=' + params.value.tds_rate_id;
    if (params.value.vds_rate_id) query += '&vds_rate_id=' + params.value.vds_rate_id;
    query += '&offset=' + params.value.offset
    query += '&is_excluded_challan_general=1';
    return query;
}

onMounted(() => {
    Promise.all([
        getAccountHeads(),
        getTdsRates(),
        getVdsRates(),
        getCashAndBank(),
        getAccountHeadList()
    ]);
})

</script>

<style>
.tds-vds-query-setter .action-btn-setter {
    margin-bottom: 1.5% !important;
}
.challan-inline-spacing {
    margin-top: 6px !important;
}
</style>